import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { Role } from '../models';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RoleService {

  private path = '/roles';

  constructor(private http: AlloxApiService) { }

  public fetchAll() {
    const url = this.path;
    return this.http.get<[]>(url).pipe(
      map(objs => objs.map(obj => new Role(obj))),
    );
  }
}
